"use client";
import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import IMAGES from "@/data/assetData";
import Image from "next/image";

const TESTIMONIAL_IMAGES = [
  { src: IMAGES.Testimonial_1, alt: "Customer Testimonial 1" },
  { src: IMAGES.Testimonial_2, alt: "Customer Testimonial 2" },
  { src: IMAGES.Testimonial_3, alt: "Customer Testimonial 3" },
];

const Testimonials = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    Autoplay({ delay: 5000, stopOnInteraction: true }),
  ]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi, onSelect]);

  return (
    <section className="relative flex flex-col md960:flex-row items-center md960:justify-evenly my-12 md960:my-16 mx-[5%] md960:mx-[10%] md960:min-h-[545px] md960:overflow-hidden bg-[url('/images/aeroplane_background.svg')] bg-no-repeat bg-center bg-contain z-[1] gap-[30px]" aria-labelledby="testimonial-heading">
      <div className="w-full md960:flex-1 md960:w-[450px] text-center md960:text-left">
        <h2 id="testimonial-heading" className="font-poppins text-2xl md960:text-[38px] font-semibold text-textPrimary leading-tight md960:leading-[1.2]">
          Discover the largest <br /> &amp; the most{" "}
          <span className="inline-flex">
            <span className="text-teal">Trusted</span>
            <sup className="ml-[7px] md960:-ml-2 align-top">
              <Image
                src={IMAGES.security_illustration}
                alt="Trust Shield"
                width={35}
                height={36}
                priority
              />
            </sup>
          </span>
          <br />
          Bike and Car rental platform
        </h2>
        <p className="pt-2 text-sm md960:text-lg font-normal text-textSecondary leading-relaxed">
          See what our customers say about our rental service.
        </p>
      </div>

      <div className="testimonial-carousel w-full md960:absolute md960:left-[60%] md960:max-w-[290px]">
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex">
            {TESTIMONIAL_IMAGES.map((image, index) => (
              <div
                key={index}
                className="min-w-0 flex-[0_0_100%]"
              >
                <Image
                  src={image.src}
                  alt={image.alt}
                  width={500}
                  height={300}
                  style={{ width: '100%', height: 'auto' }}
                  priority={index === 0}
                  loading={index === 0 ? undefined : "lazy"}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-[5px] mt-2.5">
          {TESTIMONIAL_IMAGES.map((_, index) => (
            <button
              key={index}
              type="button"
              className="relative w-6 h-6 flex items-center justify-center cursor-pointer bg-transparent"
              onClick={() => emblaApi?.scrollTo(index)}
              aria-label={`Go to slide ${index + 1}`}
            >
              <span className={`block w-2.5 h-2.5 rounded-full transition-colors duration-300 ${
                index === selectedIndex
                  ? "bg-[var(--color-accent-cyan)]"
                  : "bg-[rgba(110,211,220,0.2)]"
              }`} />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
